// Row 28.1 — markdown-to-safe-HTML wrapper. `marked` (small, MIT, the standard lightweight
// markdown parser) + the already-present `dompurify` (this repo's existing XSS-sanitization
// dependency) — no new sanitization mechanism invented.
import { marked } from "marked";
import DOMPurify from "dompurify";

export function renderMarkdown(source: string): string {
  const html = marked.parse(source, { async: false });
  return DOMPurify.sanitize(html);
}
